import { DialogContent, DialogOverlay } from '@reach/dialog';
import classNames from 'classnames';

import useStyles from './styles';
import IMobileSliderModal from './types';

export const MODAL_ROOT_ID = 'root';

import '@reach/dialog/styles.css';

function MobileSliderModal({
  className,
  backdropClassName,
  children,
  onClose,
  alert,
  alertClassName,
}: IMobileSliderModal) {
  const classes = useStyles();

  return (
    <DialogOverlay className={classNames(classes.root, backdropClassName)} onDismiss={onClose}>
      {alert && (
        <DialogContent className={alertClassName} aria-label="dialog">
          {alert}
        </DialogContent>
      )}

      <DialogContent aria-label="dialog" className={classNames(classes.modal, className)}>
        {children}
      </DialogContent>
    </DialogOverlay>
  );
}

export default MobileSliderModal;
